export const gfWinners = {
  "2015": "North QLD Cowboys",
  "2016": "Cronulla Sharks",
  "2017": "Melbourne Storm",
  "2018": "Sydney Roosters",
  "2019": "Sydney Roosters",
  "2020": "Melbourne Storm",
  "2021": "Penrith Panthers",
  "2022": "Penrith Panthers",
}